import React from 'react';
import { Button, PopUp } from 'geniebook-ui/dist';
import { CDN_URL } from '@utils/constants/url.constants';

export interface ICancelHintPopUpProps {
  onClose: () => void;
  onConfirm: () => void;
  date: string;
}

const CancelHintPopUp = (props: ICancelHintPopUpProps) => {
  return (
    <PopUp
      onClose={() => {}}
      className={'px-8 py-6 max-w-[400px]'}
      img={
        <img
          className={'w-full max-w-[400px] block mx-auto mb-4'}
          src={CDN_URL + 'assets/images/subscription/cancel-subs.svg'}
          alt={''}
        />
      }
      buttonGroup={
        <div>
          <Button
            className={
              '!max-w-[calc(100%-2px)] !h-[56px] !font-extrabold hover:transform hover:!scale-[1.01]'
            }
            onClick={props.onConfirm}
          >
            Confirm cancellation
          </Button>
          <Button
            className={'!max-w-[calc(100%-2px)] !h-[56px] !font-extrabold'}
            variant={'secondary'}
            onClick={props.onClose}
          >
            Dismiss
          </Button>
        </div>
      }
      description={"You'll lose access to unlimited hints on " + props.date}
      title={
        <div className={'font-extrabold text-xl leading-[1.2]'}>
          Cancel your subscription?
        </div>
      }
    />
  );
};

export default CancelHintPopUp;
